import {connect} from "react-redux";
import RouteRow from "./RouteRow";

const mapStateToProps = state => ({
    
});

const mapDispatchToProps = dispatch => ({
    
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RouteRow);